import selectedUserReducer from "./SelectedUser";

export const reducer = selectedUserReducer;
export * from "./SelectedUser";